import React from 'react'
import myImg from '../../assets/images/apropos.png'
const Apropos = () => {
  return (
    <div className='grid apropos-img grid-cols-1 sm:grid-cols-2 md:grid-cols-2 items-start pb-8 pt-24 space-x-3'>
      <div className='px-5 w-full grid place-content-center'>
        <div className='h-full w-4/5 grid gap-3'>
          <h1 className='text-4xl text-[#006DC4]'>
            <span className='font-semibold'>Présentation succincte du projet : </span> <br />
            Origine, financement, et objectifs principaux.
          </h1>
          <div className='max-h-[450px] overflow-y-scroll'>
            <p className='text-[#5A5A5A] p-4 overflow-hidden'>
            Le projet Gestion Intégrée des Ressources en Eaux douces de la Zone Humide de Soliman – GIREauSOL. vise à la gestion des 
eaux douces de la zone humide de Soliman à travers la valorisation des données scientifiques sur l’état et la qualité des eaux et de la 
biodiversité de la zone en relation,  mené par l’Association de l’Environnement et du Développement à Soliman (AEDS) et financé 
par le Fonds de partenariat pour les écosystèmes critiques (CEPF). <br />
Ce fonds est une initiative conjointe de l'Agence française 
de développement, de Conservation International, de l'Union européenne, de la Fondation Hans Wilsdorf, du Fonds pour 
l'environnement mondial, du gouvernement japonais et de la Banque mondiale. Dans le cadre du hotspot méditerranéen, 
des financements complémentaires ont été apportés par la Fondation MAVA, la Fondation Audemars-Watkins, ainsi que par 
l’Initiative des donateurs pour les écosystèmes d'eau douce méditerranéens (DIMFE), contribuant ainsi à renforcer les 
actions de préservation et de gestion durable des ressources en eau. 
</p>
          </div>
        </div>
      </div>

      <div className='px-5 w-4/5 place-content-center'>
        <div className='grid gap-8 justify-start'>
          <h1 className='text-5xl font-semibold text-[#006DC4]'>
          Mission et vision :<br />
            <span className='text-yellow-300 text-2xl'>"Protéger et valoriser les ressources naturelles de 
            Soliman.</span>
          </h1>
          <p className='text-[#5A5A5A] text-lg'>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry...
          </p>
          <img src={myImg} alt='Project illustration' />
        </div>
      </div>
    </div>
  );

}

export default Apropos